export default "__VITE_ASSET__eZN4h38w__"